import React from "react";
// import Highlights from "./Highlights";
import ModuloProductoEtapa from "./ModuloProductoEtapa";
import CarouselAliadosBasf from "./CarouselAliadosBasf";
import Footer from "./Footer";
import { Link } from "react-router-dom";
// import {
//   BrowserRouter as Router,
//   HashRouter,
//   Switch,
//   Route,
//   Link,
// } from "react-router-dom";
import i18n from "../i18n/index.js";
import "../scss/Aliados.scss";

function Basf() {
  return (
    <>
      <section className="aliado-Fedea">
        <div className="space"></div>
        <div className="Hero">
          <img className="banner-hero" src="assets/hero-basf.png" alt="hero" />
          <div className="info-banner">
            <div className="sectionclass">
              <p>Partners</p>
            </div>
            <div className="nombre-aliado">
              <img
                src="/assets/logo-basf.png"
                alt="logo"
                className="logo-aliado basf"
              />
            </div>
          </div>
        </div>
        <div className="descripccion py-5 mt-5 mt-md-0">
          <img
            src="/assets/deco-gold.svg"
            alt="deco"
            className="deco-descrips"
          />
          <div className="w-90">
            <div className="container">
              <div className="col-12 px-3 pl-md-0 d-flex align-items-center">
                <p className="title-presentacion mb-3 mb-md-0 pb-3">
                  {i18n.t("partners.basf.sectionTwo.title01")}
                </p>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.basf.sectionTwo.desc01")}
                  </p>
                </div>
                <div className="col-md-6">
                  <p className="text-aliado">
                    {i18n.t("partners.basf.sectionTwo.desc02")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="servicios py-5">
          <div className="blue-servicio"></div>
          <div className="little-gold"></div>
          <div className="big-gold"></div>
          <div className="grey-servicios"></div>
          <img src="/assets/gold-wave.svg" alt="deco" className="wave-03" />
          <div className="container">
            <div className="grey-servicio"></div>
            <h3>{i18n.t("partners.basf.sectionThree.title")}</h3>
            <div className="row py-3 mx-3 mx-md-0">
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.basf.sectionThree.box01.title")}
                  imgEtapa="../assets/planta00.jpg"
                  claseImgEtapa2=" "
                  href01="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/heat.html"
                  imgparter01="../assets/basf-01.svg"
                  href02="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/zidua-pack.html"
                  imgpartner01="basf-siembra"
                  imgpartner02="basf-siembra"
                  imgparter02="../assets/basf-02.svg"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa={i18n.t("partners.basf.sectionThree.box02.title")}
                  imgEtapa="../assets/planta0.jpg"
                  claseImgEtapa6siembra=" "
                  imgparter01="../assets/basf-03.svg"
                  href01="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/gestus.html"
                  imgpartner201="basf-siembra"
                  imgparter02="../assets/basf-06.svg"
                  href02="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/hicoat-super-mani.html"
                  imgpartner202="basf-siembra"
                  imgparter03="../assets/basf-04.svg"
                  href03="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/color-coat.html"
                  imgpartner203="basf-siembra"
                  imgparter04="../assets/basf-07.svg"
                  href04="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/hicoat-super-mani.html"
                  imgpartner204="basf-siembra"
                  imgparter05="../assets/basf-05.svg"
                  href05="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/adhere-mani.html"
                  imgpartner205="basf-siembra"
                  imgparter06="../assets/basf-08.svg"
                  href06="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/histick-2-mani.html"
                  imgpartner206="basf-siembra"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="V2"
                  imgEtapa="../assets/planta3.jpg"
                  claseImgEtapa32=" "
                  imgparter01="../assets/basf-09.svg"
                  href01="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/basagran.html"
                  imgpartner="basf-siembra"
                  imgparter02="../assets/basf-10.svg"
                  href02="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/zynion.html"
                  imgparter03="../assets/basf-11.svg"
                  href03="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/cadre-70-dg.html"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="V6 - R1"
                  imgEtapa="../assets/planta4.jpg"
                  claseImgEtapa3v6=" "
                  imgparter01="../assets/basf-12.svg"
                  href01="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/bellis.html"
                  imgpartner="basf-siembra"
                  imgparter02="../assets/basf-13.svg"
                  href02="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/opera.html"
                  imgparter03="../assets/basf-14.svg"
                  href03="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/orquesta-ultra.html"
                />
              </div>
              <div className="col-md-6 px-0 px-md-auto">
                <ModuloProductoEtapa
                  titleEtapa="R3"
                  imgEtapa="../assets/planta6.jpg"
                  claseImgEtapa32=" "
                  imgparter01="../assets/basf-15.svg"
                  href01="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/orquesta-ultra.html"
                  imgpartner="basf-siembra"
                  imgparter02="../assets/basf-16.svg"
                  href02="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/opera.html"
                  imgparter03="../assets/basf-17.svg"
                  href03="https://agriculture.basf.com/ar/es/proteccion-de-cultivos-y-semillas/productos/duett-plus.html"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="Beneficios py-5 d-md-flex">
          <img
            src="/assets/gold-beneficios.svg"
            alt="deco"
            className="gold-beneficios"
          />
          <div className="container">
            <h4 className="mb-4">
              {i18n.t("partners.basf.sectionSix.title")}{" "}
            </h4>
            <CarouselAliadosBasf />
            {/* <div className="row">
                <div className="col-md-4">
                  <a href="https://www.multiplicabasf.com.ar/registrate/" target="_blank">
                    <div className="cuadro-container">
                      <div className="d-flex flex-column">
                        <img src="/assets/multiplica.png" alt="multiplica"/>
                        <p>{i18n.t('partners.basf.sectionSix.box01')}
                        <br/> 
                        {i18n.t('partners.basf.sectionSix.box01reg')} 
                        <a href="https://www.multiplicabasf.com.ar/registrate/"target="_blank">
                        {i18n.t('partners.basf.sectionSix.box01link')}
                        </a> 
                        {i18n.t('partners.basf.sectionSix.box01final')}</p>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-4">
                  <a href="https://agriculture.basf.com/ar/es/sustentabilidad/Academia-Agro.html" target="_blank">
                    <div className="cuadro-container">
                      <div className="d-flex flex-column">
                        <img src="/assets/academia-agro.svg" alt="/academia-agro"/>
                        <p>{i18n.t('partners.basf.sectionSix.box02')}<br/><a href="https://agriculture.basf.com/ar/es/sustentabilidad/Academia-Agro.html" target="_blank">{i18n.t('partners.basf.sectionSix.box02link')}</a></p>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-4">
                  <a href="https://wa.me/5491134215552" target="_blank">
                    <div className="cuadro-container">
                      <div className="d-flex flex-column">
                        <img src="/assets/linea-wpp.png" alt="linea-wpp"/>
                        <p>{i18n.t('partners.basf.sectionSix.box03')}</p>
                        <p className="dest">+54 911 3421 5552</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div> */}
          </div>
        </div>
        <div className="cta-aliados py-5">
          <div className="container">
            <div className="col-12">
              <div href="#" className="interesado-aliados">
                <Link to="/contacto">
                  <div className="row justify-content-center align-items-center">
                    <p>{i18n.t("partners.cta")}</p>
                    <img
                      src="/assets/arrow-next.svg"
                      alt="arrow"
                      className="arrow-cta"
                    />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Basf;
